// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { SpectrumModule } from "modules/workflows/Streamer/Spectrum/SpectrumModule";

@autoinject
export class StreamerSpectrumSettingsModal extends SettingsModal<SpectrumModule> {}
